import React, { useState } from 'react';
import { Box, Button, Heading, Span, VStack, Text } from '@bpba/ui-components';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import { ArrepentimientoPreSolicitudSP } from '../rest/models/ArrepentimientoPreSolicitudSP';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useMutation, useQuery } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { ArrepentimientoPreSolicitudSPApiRQ } from '../rest/models/ArrepentimientoPreSolicitudSPApiRQ';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { postArrepentimientoPreSolicitudSP } from '../rest/mutations/postArrepentimientoPreSolicitudSP';
import { Result } from './Result';
import { Queries } from '../rest/Queries';
import { ResultError } from './ResultError';
import { getArrepentimiento } from '../rest/queries/getArrepentimiento';
import { format } from "date-fns";
import ComboSucursales from "./ComboSucursales";
import '../pages/DatePickerCustom.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";


const ArrepentimientoPreSolicitudComponente: React.FC = () => {


    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [errorServicio, setErrorServicio] = useState<boolean>(false);
    const [mensajeError, setMensajeError] = useState<string>("");
    const { register, handleSubmit, control, setValue, reset, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange'
    });
    const REQUIRED_FIELD = "Campo requerido.";
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [postArrepentimientoPreSolicitudAPI, { loading: loadingArrepentimiento }] = useMutation<Mutations>(postArrepentimientoPreSolicitudSP);
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<React.ReactNode>(<></>);
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [startDate, setStartDate] = useState(new Date());
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let origenSolicitud = params.get('origenSolicitud');
    let path = search.split("?");
    let idSolicitudASeparar = path[path.length - 1];
    let idSolicitud = Number.parseInt(idSolicitudASeparar.split("-")[0]) / 329;
    let idSecParamString = idSolicitudASeparar.split("-")[1];
    let idSecParam = Number.parseInt(idSecParamString);
    const [value] = useState(new Date());
    let dias = value.getDate() - 14;
    if (new Date(dias).getDay() === 0) {//es domingo
        dias += 1;
    } else if (new Date(dias).getDay() === 6) {//sabado
        dias += 2;
    }
    const mes = value.getMonth();
    const año = value.getFullYear();



    const { data: { arrepentimiento } = {}, loading } = useQuery<Queries>(getArrepentimiento, {
        variables: { idArrepentimiento: idSolicitud, sec: idSecParam }, skip: !idSolicitud, onCompleted(data) {

            if (data.arrepentimiento.data != null) {
                setValue("cuit", data.arrepentimiento.data?.cuit);
                setValue("email", data.arrepentimiento.data?.email);
            
            } else if (data.arrepentimiento?.resultado === "error") {
        
                if (data.arrepentimiento?.error.includes("no existe")) {
                    setServicioOk(true);
                    setErrorServicio(true);
                    setMensajeRtaServicio(<Text>{data.arrepentimiento?.error}</Text>)
                } else {
                 
                    setServicioOk(true);
                    setErrorServicio(true);
                    setMensajeRtaServicio(<Text>Ha ocurrido un problema, inténtelo mas tarde.</Text>)
                }
            } else {
          
                setServicioOk(true);
                setErrorServicio(true);
                setMensajeRtaServicio(<Text>Ha ocurrido un problema, inténtelo mas tarde.</Text>)
            }

        }


        , onError(e: any) {
        
            if (e.networkError.statusCode === 409) {
                setErrorServicio(true);
                setMensajeError(JSON.parse(JSON.stringify(e.networkError)).result.Message);

            }
        }
    });


    const onSubmit: SubmitHandler<ArrepentimientoPreSolicitudSP> = async (data: ArrepentimientoPreSolicitudSP) => {

        const token = executeRecaptcha && (await executeRecaptcha('Arrepentido'));


        let datos: ArrepentimientoPreSolicitudSPApiRQ = {
            "googleToken": token,
            "razonSocial": arrepentimiento ? arrepentimiento?.data?.razonSocial : "",
            "cuit": arrepentimiento ? arrepentimiento?.data?.cuit.toString() : "",
            "email": arrepentimiento ? arrepentimiento?.data?.email : "",
            "nroSecuencia": arrepentimiento?.data.nroSecuencia ? arrepentimiento.data.nroSecuencia : 0,
            "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
            "sucursal": Number.parseInt(data.sucursal),
            "productoRevocar": Number.parseInt((data.productoRevocar ? data.productoRevocar.toString() : "0")),
            "digitosProductoRevocar": Number.parseInt((data.digitosProductoRevocar ? data.digitosProductoRevocar.toString() : "0")),
            "fechaContratacion": startDate ? format(startDate, 'yyyy-MM-dd').toLocaleString() : "",
            "estado": 2,
            "observaciones": "",
            "origenSolicitud": origenSolicitud === null ? "" : origenSolicitud
        };


        await postArrepentimientoPreSolicitudAPI({ variables: { input: datos } }).then(response => {



            if (response !== null || response !== undefined) {
                if (response.data?.ArrepentimientoPreSolicitudSPApiRS.resultado === 'ok') {
                    setServicioOk(true);
                    setMensajeRtaServicio("Solicitud creada con éxito. En los próximos días nos contactaremos con vos.");
                } else if (response.data?.ArrepentimientoPreSolicitudSPApiRS.error.includes('existe')) {
                    setServicioOk(true);
                    setMensajeRtaServicio("Ya existe un registro con este cuit");
                } else {
                    setServicioOk(true);
                    setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                }
            }
        }).catch((e) => {

            if (e.networkError.statusCode === 500) {
                setServicioOk(false);
                setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");

            }
            else if (e.networkError.statusCode === 409) {
                setServicioOk(false);
                setMensajeErrorPostProspecto(JSON.parse(JSON.stringify(e.networkError)).result.Message);

            } else {
                setServicioOk(false);
                setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
            }
        })
 
    }

    if (loadingArrepentimiento || loading) return <SpinnerCajas />;

    const handleReset = () => {
        reset({});
        window.location.href="/Formulario/Arrepentimiento/Index";
    };


    if (servicioOk) return (
        <Result handleReset={handleReset}>
            <VStack>
                <Heading level={2} fontWeight={400} color="primary.0" tabIndex={0}>{mensajeRtaServicio}</Heading>
            </VStack>
        </Result>
    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );

    return (

        <Box>
            <VStack>
                <form noValidate onSubmit={handleSubmit(onSubmit)} style={{ minHeight: '400px', display: "flex", flexDirection: "column", marginBottom: "4rem" }}>

                    <Heading level={3} mb={'20px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>
                    {errorServicio ?
                        <VStack>
                            <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {mensajeError}
                            </Span>
                        </VStack> : <></>
                    }

                    <VStack>
                        <input type={"text"} tabIndex={0}
                            {...register("cuit", {
                                required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                maxLength: 11
                            })}
                            name='cuit' id='cuit' placeholder='CUIT ej: 30123456789' maxLength={11} minLength={11} disabled />

                    </VStack>
                    <VStack mt={"20px"}>
                        <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} disabled />
                    </VStack>



                    <VStack mr={"0.5rem"} mt={"20px"}>
                        <select tabIndex={0} aria-label={"Seleccione producto a revocar"}
                            style={{ width: "100%" }}
                            {...register("productoRevocar", { required: REQUIRED_FIELD })} name="productoRevocar" placeholder='Producto a revocar' >
                            <option value="">Seleccione producto a revocar</option>
                            <option value={1}>Caja de ahorros</option>
                            <option value={2}>Cuenta corriente</option>
                            <option value={3}>Tarjeta de crédito Visa</option>
                            <option value={4}>Tarjeta de crédito Mastercard</option>
                            <option value={5}>Paquete de productos</option>
                            <option value={6}>Préstamos personales</option>
                            <option value={7}>Préstamos hipotecarios</option>
                            <option value={8}>Programa millas: Aerolíneas Plus</option>
                            <option value={9}>Banca Internet Provincia (BIP Individuos)</option>
                            <option value={10}>Seguro de Vida: Más Actual TAR</option>
                            <option value={11}>Seguro de vida: ProvinFlex</option>
                            <option value={12}>Seguro de vida colectivo - Vida Fácil</option>
                            <option value={13}>Seguro por robo en cajero automático</option>
                            <option value={14}>Otros seguros</option>
                        </select>
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.productoRevocar ? "* " + errors.productoRevocar.message : ""}</Span>
                    </VStack>



                    <VStack mt={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }} marginBottom={"8px"}>
                            Fecha de contratación
                        </Span>

                         <DatePicker
                                    aria-label={"Seleccione la fecha con el formato dia dia-mes mes - año en dos digitos"}
                                    {...register("fechaContratacion")}
                                    selected={startDate}
                                    minDate={new Date(año, mes, dias)}
                                    maxDate={new Date()}
                                    locale={es}
                                    filterDate={(date: Date) => date.getDay() !== 0 && date.getDay() !== 6}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    dateFormat={"yy-MM-dd"}
                                    showIcon
                                    className={'react-date-picker'}
                                    onChange={(date) => { date ? setStartDate(date) : setStartDate(new Date()) }}
                                
                                />
                            
                        

                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.fechaContratacion ? "* Campo requerido. " + errors.fechaContratacion.message : ""}</Span>

                    </VStack>


                    <VStack mr={"0.5rem"}>
                        <input type={'text'} {...register("digitosProductoRevocar", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} name="digitosProductoRevocar" placeholder='Últimos 4 dígitos del producto a revocar' maxLength={4} style={{ marginTop: "10px" }} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.digitosProductoRevocar ? "* " + errors.digitosProductoRevocar.message : ""}</Span>
                    </VStack>

                    <VStack mt={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                            Teléfono de contacto
                        </Span>
                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row', marginTop: 0 }}>
                            <VStack width={"40%"} mr={"0.5rem"}>
                                <input style={{ width: "100%", marginTop: "8px", padding: "0.375rem 0 0.375rem 0.75rem" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Área: ejemplo 011' maxLength={4} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                            </VStack>
                            <VStack width={"60%"} >
                                <input tabIndex={0} style={{ width: "100%", marginTop: "8px", padding: "0.375rem 0 0.375rem 0.75rem"  }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Número: fijo / cel sin el 15' maxLength={14} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                            </VStack>
                        </VStack>
                    </VStack>

                    <Controller
                        control={control}
                        name="sucursal"
                        rules={{ required: true }}
                        render={({ field }) => {
                            return <ComboSucursales onChangeValue={(e) => { field.onChange(e) }} titulo={"Sucursal donde querés finalizar el trámite"}  />
                        }}
                    />

                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.sucursal ? "* Campo requerido." + errors.sucursal.message : ""}</Span>

                    <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>

                </form>
            </VStack>

        </Box>

    )

};



export default ArrepentimientoPreSolicitudComponente;
